<template>
  <div>
    <guide-share-header :wxa-page="wxaPage" :wxa-page-param="wxaPageParam" :name="shareHaderName"></guide-share-header>
           <div class="guide-page-right">

        <div class="line-title">

            <div class="line-title-content">线下订单（仅支持官网下单）</div>

        </div>

         <div class="step-box">

                <div class="step-title">
                    <div class="step-title-number">01</div>
                    <div class="step-title-content">填写出行信息，点击「开始办理」进入下一步；</div>
                </div>

                <div class="step-subtitle"></div>

                <div class="step-content">
                    <img v-bind:src="imageBaseUrl + imageIndex[0]" alt="">
                </div>

            </div>

            <div class="step-box">

                <div class="step-title">
                    <div class="step-title-number">02</div>
                    <div class="step-title-content">选择「线下邮寄资料」，进入下一步；</div>
                </div>

                <div class="step-subtitle">
                    <p>注：若线下邮寄资料显示该资料暂不支持线下寄送，则表明该商品仅支持在线上传资料，若有疑惑，您可咨询在线客服。</p>
                </div>

                <div class="step-content">
                    <img v-bind:src="imageBaseUrl + imageIndex[1]" alt="">
                </div>

            </div>

            <div class="step-box">

                <div class="step-title">
                    <div class="step-title-number">03</div>
                    <div class="step-title-content">核对资料已备齐，勾选「确认以上资料已备齐」，点击「确定」进入订单确认页；</div>
                </div>

                <div class="step-subtitle"></div>

                <div class="step-content">
                    <img v-bind:src="imageBaseUrl + imageIndex[2]" alt="">
                </div>

            </div>

            <div class="step-box">

                <div class="step-title">
                    <div class="step-title-number">04</div>
                    <div class="step-title-content">支付订单。</div>
                </div>

                <div class="step-subtitle"></div>

                <div class="step-content">
                    <img v-bind:src="imageBaseUrl + imageIndex[3]" alt="">
                </div>

            </div>

    </div>
  </div>
</template>

<script>
import sensorsdata from 'sa-sdk-javascript';
import GuideShareHeader from '../component/GuideShareHeader';

export default {
  name: 'OfflineOrder',
  components: {
    GuideShareHeader,
  },
  data() {
    return {
      wxaPage: '',
      wxaPageParam: '',
      shareHaderName: '线下订单',
      imageBaseUrl: 'https://o.666visa.cn/static/common/guides/',
      imageIndex: ['9_01.png', '9_02.png', '9_03.png', '9_04.png'],
    };
  },
  mounted() {
    sensorsdata.track('UserGuide', {
      guide_name: '线下订单',
    });
  },
};
</script>
<style lang=less>
@import "../../../assets/less/guide.less";
.guide-page-right {
  padding: 30px 70px 30px 70px;
}
</style>




// WEBPACK FOOTER //
// src/pages/guide/sub/offlineOrder.vue